import { defineComponent as s, computed as n, openBlock as a, createElementBlock as c, normalizeStyle as m, normalizeClass as p, unref as u, renderSlot as f } from "vue";
import { useNamespace as i } from "./index559.js";
var _ = /* @__PURE__ */ s({
  name: "ElFooter",
  __name: "footer",
  props: {
    height: { type: [String, null], required: !1, default: null }
  },
  setup(o) {
    const e = o, t = i("footer"), r = n(
      () => e.height ? t.cssVarBlock({ height: e.height }) : {}
    );
    return (l, h) => (a(), c(
      "footer",
      {
        class: p(u(t).b()),
        style: m(r.value)
      },
      [
        f(l.$slots, "default")
      ],
      6
      /* CLASS, STYLE */
    ));
  }
});
export {
  _ as default
};
